import React from 'react'

import { useTranslation } from 'react-i18next'

import logo from '../../assets/logo.png'
import { Link } from '../Link'

import { LanguageSwitcher } from './LanguageSwitcher'

export const Header: React.FC = () => {
    const { t } = useTranslation()
    const [isMenuOpen, setIsMenuOpen] = React.useState(false)
    const headerMenu = [
        { href: 'about-me', text: t('navigation.aboutMe') },
        { href: 'services', text: t('navigation.services') },
        { href: 'office-hours', text: t('navigation.officeHours') },
        { href: 'contact', text: t('navigation.contact') },
        { href: 'team', text: t('navigation.team') },
        { href: 'download', text: t('navigation.download') },
    ]

    const handleMenuClick = (href: string) => {
        setIsMenuOpen(false)
        window.location.hash = href
    }

    return (
        <header className="sticky top-0 z-50 bg-primary-green">
            <div className="container max-w-container-s mx-auto py-2 lg:gap-8 flex justify-between items-center h-[75px] text-white">
                <a href="/" className="flex items-center">
                    <img src={logo} alt="Logo" className="w-auto h-12 ml-2" />
                </a>
                <button className="lg:hidden text-white z-50 mr-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24"
                        xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
                <nav
                    className={`
                fixed top-0 right-0
                flex flex-col justify-center
                bg-primary-green
                w-64 p-6
                transition-transform duration-300 ease-in-out
                lg:relative lg:transform-none lg:flex-row lg:w-auto lg:p-0 lg:bg-transparent
                ${isMenuOpen ? 'block' : 'hidden'} 
                lg:translate-x-0 lg:flex lg:items-center lg:justify-center lg:mr-2
                `}>
                    <ul className="flex flex-col space-y-2 mt-10 lg:flex-row lg:space-x-8 lg:space-y-0 lg:mt-0">
                        {headerMenu.map((item, index) => (
                            <li
                                key={item.href}
                                className={`
                                mb-2 lg:mb-0 
                                ${index === headerMenu.length - 1 ? '' : 'border-b border-white/20 lg:border-b-0'} 
                                pb-2 lg:pb-0
                            `}>
                                <Link href={`/#${item.href}`} onClick={() => handleMenuClick(item.href)}>
                                    {item.text}
                                </Link>
                            </li>
                        ))}
                        <li>
                            <LanguageSwitcher />
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    )
}
